<template>
  <div>
    <a-table
      :pagination="false"
      :columns="columns"
      :data-source="data"
      :row-key="(record, index) => index"
    >
      <div slot="order" slot-scope="text, record, index">
        {{ index + 1 }}
      </div>
      <div slot="reimbursementDesc" slot-scope="text, record">
        <a-input
          :disabled="disabled"
          class="ml10"
          placeholder="请填写报销描述"
          @blur="monitorValue"
          v-model="record.reimbursementDesc"
        />
      </div>
      <div slot-scope="text, record" slot="reimbursementFee">
        <a-input-number
          :disabled="disabled"
          :min="0"
          :max="1000000000"
          class="ml10 w300"
          placeholder="请填写报销金额"
          @blur="changeNumber"
          v-model="record.reimbursementFee"
        />
      </div>
    </a-table>
    <div class="accessory-btn" v-if="!disabled">
      <a-button icon="plus" @click="addcate">报销事项分类 </a-button>
    </div>
  </div>
</template>
<script>
const columns = [
  {
    title: "序号",
    dataIndex: "order",
    key: "order",
    width: 80,
    align: "center",
    scopedSlots: { customRender: "order" }
  },
  {
    key: "reimbursementDesc",
    scopedSlots: { customRender: "reimbursementDesc" },
    title: "报销描述",
    align: "left"
  },
  {
    key: "reimbursementFee",
    scopedSlots: { customRender: "reimbursementFee" },
    title: "报销金额 / 元",
    align: "left"
  }
];
export default {
  props: ["disabled", "resDetail", "reimbursementAssociations"],
  model: {
    event: "input",
    prop: "reimbursementAssociations"
  },
  data() {
    return {
      columns,
      data: [],
      ifAbleAdd: true
    };
  },
  watch: {
    resDetail(val) {
      if (val) {
        this.data = val;
      }
    }
  },
  mounted() {
    this.data = this.resDetail ? this.resDetail : [];
  },
  methods: {
    changeNumber() {
      //计算合计金额
      let allNumber = 0;
      this.data.forEach((item, index) => {
        if (item.reimbursementFee) {
          allNumber += item.reimbursementFee;
        }
      });
      this.monitorValue()
      this.$parent.resDetail.fee = allNumber;
      this.$parent.updataFee();
    },
    // 监听表格行是否都填入输入
    monitorValue() {
      let emitData = [];
      this.data.forEach(item => {
        emitData.push({
          reimbursementDesc: item.reimbursementDesc,
          reimbursementFee: item.reimbursementFee
        });
      });
      this.$emit("input", emitData);
    },
    addcate() {
      if (this.data.length < 4) {
        this.ifAbleAdd = true;
        // 判断当前表格是否含有空数据
        if (this.data && this.data.length != 0) {
          this.data.forEach((item, index) => {
            if (item.reimbursementFee == "" && item.reimbursementDesc == "") {
              this.$message.warning("请先输入当前报销事项分类");
              this.ifAbleAdd = false;
            }
          });
        }
        if (this.ifAbleAdd == true) {
          let data = {
            id: this.data.length + 1,
            reimbursementFee: "",
            reimbursementDesc: ""
          };
          this.data.push(data);
        }
      } else {
        this.$message.warning(
          "为了方便快速浏览，请放置4条以内的支付描述，文本不能添加的请再提交报销申请表单"
        );
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.detial-cont-view {
  background: #fff;
  padding: 30px;
  .accessory-btn {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ClaimExpense/components/reimItems.vue